<template>
  <v-dialog
    id="fullscreenDialog"
    fullscreen
    v-model="$store.getters.detailsMode"
    hide-overlay
    persistent
    transition="dialog-bottom-transition"
    :close-delay="500"
    :small="$vuetify.breakpoint.smAndDown"
  >
    <div class="contentWrapper">
      <v-toolbar dark color="#041E42">
        <h1
          :class="{'ml-15 toolbarHeading': $vuetify.breakpoint.mdAndUp, 'ml-12 toolbarHeading': $vuetify.breakpoint.smAndDown}"
          :style="$vuetify.breakpoint.xs ? {'font-size': '16px'} : {'font-size': '20px'}">
          {{ title }}
        </h1>
        <v-btn
          icon
          dark
          :small="$vuetify.breakpoint.smAndDown"
          @click="closeDetailsMode"
          class="ml-0 close--button"
          aria-label="close">
          <v-icon color="white">mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-row justify="center"
             :class="{'mt-10 py-10 mx-3': $vuetify.breakpoint.mdAndUp, 'mt-7 px-3': $vuetify.breakpoint.smOnly, 'mt-0 px-0': $vuetify.breakpoint.xsOnly}">
        <v-col lg="8" md="10" sm="11" xs="12"
               :class="{'pt-0': $vuetify.breakpoint.smAndUp, 'pt-0 pb-0': $vuetify.breakpoint.xsOnly}">
          <v-card
            :class="{'elevation-2 px-10 pb-10 pt-14 mb-8': $vuetify.breakpoint.smAndUp, 'elevation-0 rounded-0 py-10 px-0 mb-0': $vuetify.breakpoint.xsOnly, 'cardMobile':$vuetify.breakpoint.xsOnly && $store.getters.currentNotification.status !== 'Rejected' }">
            <NotificationReview show-status/>
          </v-card>
          <v-row v-if="$store.state.detailsMode && $store.getters.currentNotification.status === 'Rejected'"
                 :class="{'pt-8 px-3 pb-6': $vuetify.breakpoint.xsOnly}">
            <v-col
              :class="{'pt-0 d-flex justify-space-between': $vuetify.breakpoint.smAndUp, 'pt-0 d-flex flex-column-reverse': $vuetify.breakpoint.xsOnly}">
              <AdsButton
                icon="delete"
                button-text="Discard"
                :id="$vuetify.breakpoint.xs ? 'discardButton' : null"
                secondary
                :class="{'mt-3': $vuetify.breakpoint.xsOnly}"
                @click="showDeleteDialog"
              />
              <AdsButton
                icon="edit"
                button-text="Edit"
                @click="openEditMode"
                style="min-width: 140px;"
              />
            </v-col>
            <DiscardDialog v-model="deleteDialog" :delete-item="deleteItem" :show-delete-dialog="showDeleteDialog"/>
          </v-row>
        </v-col>
      </v-row>
    </div>
  </v-dialog>
</template>

<script>
import NotificationReview from "@/components/NotificationReview";
import DiscardDialog from "@/components/DiscardDialog";
import {AdsButton} from '@nswdoe/doe-ui-core';

export default {
  name: 'NotificationDetails',
  components: {
    NotificationReview,
    AdsButton,
    DiscardDialog
  },
  data() {
    return {
      title: "",
      deleteDialog: false,
    }
  },
  methods: {
    closeDetailsMode() {
      this.$store.commit('setDetailsMode', false);
      this.$router.push("/notifications");
      this.$store.commit('setNotification', null);
      this.$store.commit('setNotificationSetupDetails', null);
      this.$store.commit('setNotificationMessageDetails', null);
      this.$store.commit('setNotificationAudienceAndScheduling', null);
    },
    showDeleteDialog() {
      this.deleteDialog = !this.deleteDialog;
    },
    deleteItem() {
      this.$store.dispatch("deleteNotification", this.$store.getters.currentNotification.draftId)
        .then(() => {
          this.deleteDialog = false;
          this.$store.commit('setDetailsMode', false);
          this.$router.push({name: "notifications"});
        })
    },
    openEditMode() {
      this.$store.commit('setDetailsMode', false);
      this.$store.commit('setCreateMode', true);
      this.$router.push({name: 'createNotifications'});
    }
  },
  created() {
    if (this.$store.getters.currentNotification) {
      this.title = this.$store.getters.currentNotification.name;
    }
  }
}
</script>

<style scoped>
.contentWrapper {
  background-color: #F4F4F7;
  min-height: 100%;
  overflow-x: clip;
}

.cardMobile {
  min-height: calc(100vh - 56px);
}

.close--button {
  position: absolute;
}

.close--button:focus {
  border: 2px solid #ffffff !important;
  border-radius: 50% !important;
  outline: none !important;
}

.toolbarHeading {
  width: 100%;
  white-space: nowrap;
  overflow-x: hidden;
  text-overflow: ellipsis;
}
</style>
